
$(document).ready( function() {
  
  $('.blackBack,.popup a.close,.popup a.closeX').click( function() { 
    $('.blackBack').hide();
    $('.popup').hide();
  });

  /****** AJAX LOADING Scripts *******/
  
  $.ajaxSetup({cache:false});
  
  function load_ajax_content(target,source,delay,reset) { 
    if($(target).hasClass('ajaxNotLoaded')) { 
      $(target).removeClass('ajaxNotLoaded').addClass('ajaxLoading');
      setTimeout( function() { 
        $(target).load(source, function() { 
          $(target).removeClass('ajaxLoading').addClass('ajaxLoaded');
          if(reset) { $(target).addClass('ajaxNotLoaded'); } /* for things like cart preview that may need to be loaded again */
        });
      },delay);
    }
  }
  $('.clickToLoadAjax').click( function() {
    var target = $(this).attr('data-load-target');
    var source = $(this).attr('data-load-source');
    var delay = 300;
    if($(this).hasClass('noDelay')) { 
      delay = 1; 
    }
    load_ajax_content(target,source,delay,false);
  });
  
  /****** End AJAX LOADING Scripts *******/
  
  /** check if can store cookies **/
  var canStore = (window.localStorage && typeof JSON != 'undefined');
  
  /** Update Cart Count **/
  
  function update_cart_count_elements(item_count) {
    $('.cart-count').text(item_count);
    if(item_count > 0) {
      $('.cartCountHolder').removeClass('cartCountHolderEmpty');
    } else {
      $('.cartCountHolder').addClass('cartCountHolderEmpty');
    }
  }


  /****** Add to Cart Scripts *******/

  function add_to_cart($add_to_cart,$form,item_data) {
    $add_to_cart.addClass('addingToCart').prop('disabled', true);
    if($form) {
      var item_to_add = $form.serialize();
    } else if(item_data) {
      var item_to_add = item_data;
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      data: item_to_add,
      success: Shopify.onSuccess($add_to_cart),
      error: Shopify.onError
    });
  } /* end function add_to_cart */
  
  Shopify.onSuccess = function($add_to_cart) {
    setTimeout( function() {
      if($add_to_cart) {
        if($add_to_cart.hasClass('add_preorder')) {
          setTimeout( function() {
            $('.rebuy-cart__checkout-button').trigger('click');
          },500);
        }
        $add_to_cart.removeClass('addingToCart disabled');
        $add_to_cart.removeAttr("disabled");
      }
      $('body').removeClass('with-productQuickShop-active');
      $('.productQuickShop').removeClass('active');
    },500);
    setTimeout( function() {
      jQuery.getJSON('/cart.js', function(cart) {
        update_cart_count_elements(cart.item_count);
      });
    }, 1500);
  };
  
  Shopify.onError = function(XMLHttpRequest, textStatus) {
    // Shopify returns a description of the error in XMLHttpRequest.responseText.
    // It is JSON.
    // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
      alert(data.message + '(' + data.status  + '): ' + data.description);
    } else {
      alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
    }

    // $('.addtocart').removeAttr("disabled");
  };
  Shopify.fullMessagesFromErrors = function(errors) {
    var fullMessages = [];
    jQuery.each(errors, function(attribute, messages) {
      jQuery.each(messages, function(index, message) {
        fullMessages.push(attribute + ' ' + message);
      });
    });
    return fullMessages;
  };

  /** Add multiple products, with set & save discount, if applicable **/
  
  var frequently_added_discount = false;

  var $add_multiple_to_cart;
  
  Shopify.multipleItemsToAdd = [];
  Shopify.addMultipleItemsToTheCart = function() {
    if (Shopify.multipleItemsToAdd.length) {
      var item = Shopify.multipleItemsToAdd.pop();
      $.ajax({
        url: '/cart/add',
        dataType: 'json',
        type: 'post',
        data: item,
        success: Shopify.addMultipleItemsToTheCart,
        error: Shopify.addMultipleItemsToTheCart
      });
    }
    else {
      if(frequently_added_discount) {
        setTimeout( function() {
          window.location.href = '/discount/'+frequently_added_discount+'?redirect='+window.location.pathname+'#open-cart';
        },500);
        return;
      }
      setTimeout( function() {
        jQuery.getJSON('/cart.js', function(cart) {
          update_cart_count_elements(cart.item_count);
        });
        $add_multiple_to_cart.removeClass('addingToCart').prop('disabled', false);
      },2000);
    }
  };

  /** Standard Add to Cart button **/
  
  $(document.body).on('click', '.add_to_cart', function(e) {
    e.preventDefault();
    var $add_to_cart = $(this);
    var $parent_form = $add_to_cart.parents('form');
    if($parent_form.length > 0) {
      $add_multiple_to_cart = $add_to_cart;
      $add_multiple_to_cart.addClass('addingToCart').prop('disabled', true);
      if($parent_form.find('input.bundled-product-variant:checked').length > 0) {
        Shopify.multipleItemsToAdd = [];
        var main_item_to_add = $parent_form.serialize();
        var main_item_qty = Number($parent_form.find('input[name="quantity"]').val());
        Shopify.multipleItemsToAdd.push(main_item_to_add);
        $parent_form.find('input.bundled-product-variant:checked').each( function() {
          var bundled_product_variant_id = $(this).val();
          var bundled_product_qty = 1;
          if($(this).hasClass('match-quantity')) {
            bundled_product_qty = main_item_qty;
          }
          var widget_id = $(this).attr('data-widget-id');
          if (typeof widget_id !== 'undefined' && widget_id !== false) {
            Shopify.multipleItemsToAdd.push( {
              id: bundled_product_variant_id,
              quantity: bundled_product_qty,
              properties: {
                "_widget_id": widget_id
              }
            } );
          } else {
            Shopify.multipleItemsToAdd.push( {
              id: bundled_product_variant_id,
              quantity: bundled_product_qty
            } );
          }
        });
        Shopify.addMultipleItemsToTheCart();
        return;
      }
      add_to_cart($add_to_cart,$parent_form);
    }
  });

  $(document.body).on('click', '.add_to_bag_link', function(e) {
    e.preventDefault();
    var variant_id = $(this).attr('data-variant-id'),
      qty = 1;
    var item_data = {
      id: variant_id,
      quantity: qty
    }
    add_to_cart($(this),false,item_data);
  });

  /** Multiple Add to Cart button **/
  
  $('#add_frequently_bought_together').on('click', function(e) {
    e.preventDefault();
    if($(this).hasClass('addingToCart')) {
      return;
    }
    $add_multiple_to_cart = $(this);
    $add_multiple_to_cart.addClass('addingToCart');
    if($add_multiple_to_cart.hasClass('withDiscount')) {
      frequently_added_discount = $add_multiple_to_cart.attr('data-discount-code');
    }
    Shopify.multipleItemsToAdd = [];
    $('input.frequently_bought_together:checked').each( function() {
      var variant_ID = $(this).val();
      var quantity = 1;
      var widget_id = $(this).attr('data-widget-id');
      if (typeof widget_id !== 'undefined' && widget_id !== false) {
        Shopify.multipleItemsToAdd.push( {
          id: variant_ID,
          quantity: quantity,
          properties: {
            "_widget_id": widget_id
          }
        } );
      } else {
        Shopify.multipleItemsToAdd.push( {
          id: variant_ID,
          quantity: quantity
        } );
      }
    });
    Shopify.addMultipleItemsToTheCart();
  });
  
  /****** END Add to Cart Scripts *******/

  
  /****** Product Page Functions (called with product purchase changes) *******/

  function fire_product_image_slider($product, load_images) {
    var $product_image_slider = $product.find('.productImages');
    if($product_image_slider.length === 0) {
      return;
    }
    var fire_delay = 10;
    if(load_images) {
      console.log('loading slider images');
      fire_delay = 1000;
      $product_image_slider.find('img.lazyload').each( function() {
        var data_src = $(this).attr('data-src');
        $(this).attr('src', data_src);
      });
    }
    if($(window).width() > 600) {
      setTimeout( function() {
        if($product_image_slider.hasClass('slick-initialized')) {
          return;
        }
        $product_image_slider.slick({
          speed: 300,
          arrows: true,
          adaptiveHeight: false,
          dots: false
        });
      }, fire_delay);
    } else {
      if($product_image_slider.hasClass('slick-initialized')) {
        $product_image_slider.slick('unslick');
      }
    }
  } /* end fire_product_image_slider */


  /****** END Product Page Functions *******/

  
  /****** Product Purchase Options Scripts *******/

  function change_product_subscription_option($option) {
    var $parent_form = $option.parents('form');
    var $checked_subscription_option = $parent_form.find('.product-subscription-option:checked');
    var $subscription_frequency = $parent_form.find('.product-subscription-frequency');
    
    if($checked_subscription_option.val() == 'subscribe') {
      $subscription_frequency.attr('name', 'selling_plan');
      $parent_form.addClass('with-subscribeAndSave-active');
    } else {
      $subscription_frequency.removeAttr('name');
      $parent_form.removeClass('with-subscribeAndSave-active');
    }
    if($parent_form.find('.selling-plan-option').length > 0) { /* For debloat 3x stuff */
      $parent_form.find('.selling-plan-option').removeAttr('name');
    }
  } /* end function change_product_subscription_option */

  $(document.body).on('change', '.product-subscription-option', function() {
    change_product_subscription_option($(this));
  });

  function load_new_product_options($product_container, source_url) {
    var $product_options_container = $product_container.find('.options-container');
    if($product_options_container.length === 0) {
      return;
    }
    var source = source_url + '?view=purchase_options';
    if(source_url.includes('?variant')) {
      source = source_url + '&view=purchase_options';
    }
    $product_options_container.addClass('loading-options');
    $product_options_container.load(source, function() {
      $product_options_container.removeClass('loading-options');
    });
  } /* end function load_new_product_options */

  function load_new_product_images($product_container, source_url) {
    var $product_image_container = $product_container.find('.productMainImage');
    if($product_image_container.length === 0) {
      return;
    }
    var source = source_url + '?view=product_images';
    if(source_url.includes('?variant')) {
      source = source_url + '&view=product_images';
    }
    var $product_images = $product_container.find('.productImages');
    if($product_images.length > 0 && $product_images.hasClass('slick-initialized')) {
      $product_container.addClass('loading-product');
      $product_images.slick('unslick');
    }
    $product_image_container.load(source, function() {
      fire_product_image_slider($product_container, true);
      $product_container.removeClass('loading-product');
    });
  } /* end function load_new_product_images */

  function load_new_single_product($product_container,source_url) {
    $product_container.addClass('loading-product');
    var $product_images = $product_container.find('.productImages');
    if($product_images.length > 0 && $product_images.hasClass('slick-initialized')) {
      $product_images.slick('unslick');
    }
    var source = source_url + '?view=product_main';
    if(source_url.includes('?variant')) {
      source = source_url + '&view=product_main';
    }
    $product_container.load(source, function() {
      fire_product_image_slider($product_container, true);
      $product_container.removeClass('loading-product');
    });
  } /* end function load_new_single_product */

  function update_dynamic_variant_url($product_container,variant_url) {
    if($product_container.find('.dynamic-variant-url').length > 0) {
      $product_container.find('.dynamic-variant-url').attr('href',variant_url);
    }
  } /* end function update_dynamic_variant_url */
  
  function update_window_url(variant_url) { /* just to update url for sharing purpuses, ie copying url maintains selected options */
    if (history.pushState) {
      var updated_url = window.location.protocol + "//" + window.location.host + variant_url;
      window.history.pushState({path:updated_url},'',updated_url);
    }
  } /* end function update_window_url */
  
  $(document.body).on('change', '.product-variant-option', function() {
    var $parent_form = $(this).parents('form');
    var $checked_product_variant_option = $parent_form.find('.product-variant-option:checked');
    var onetime_price = $checked_product_variant_option.attr('data-price');
    var subscribe_price = $checked_product_variant_option.attr('data-subscription-price');
    $parent_form.find('.updatePrice-onetime').text(onetime_price);
    $parent_form.find('.updatePrice-subscribe').text(subscribe_price);
    
    var $parent_product_container = $parent_form.parents('.product-container');
    if($parent_product_container.length === 0) {
      return;
    }
    var variant_url = $checked_product_variant_option.attr('data-variant-url');
    var change_variant_action = $checked_product_variant_option.attr('data-action');
    if(change_variant_action == 'go_to_url') {
      window.location.href = variant_url;
      return;
    }
    if(change_variant_action == 'load_new_options') {
      load_new_product_options($parent_product_container,variant_url);
      return;
    }
    if(change_variant_action == 'load_new_images') {
      load_new_product_images($parent_product_container,variant_url);
      update_window_url(variant_url);
    }
    update_dynamic_variant_url($parent_product_container, variant_url);
    /* following for updating data-product-variant-id attr in product info table (product template only) */
    var $parent_product_template = $parent_product_container.parents('.template-product');
    if($parent_product_template.length === 0) {
      return;
    }
    var variant_id = $checked_product_variant_option.val();
    if($parent_product_template.find('.contentSection.ajaxLoaded').length > 0) {
      $parent_product_template.find('.contentSection.ajaxLoaded').addClass('ajaxNotLoaded'); /* to reset things like nutrition facts if already been clicked */
    }
    var variant_sweetness_level = $checked_product_variant_option.attr('data-sweetness-level');
    if(typeof variant_sweetness_level !== 'undefined' && variant_sweetness_level !== false && variant_sweetness_level !== 'false') {
      $parent_form.find('.update-sweetness-level').attr('data-sweetness-level', variant_sweetness_level);
    }
    var variant_sweetness_level_text = $checked_product_variant_option.attr('data-sweetness-level-text');
    if(typeof variant_sweetness_level_text !== 'undefined' && variant_sweetness_level_text !== false && variant_sweetness_level_text !== 'false') {
      $parent_form.find('.update-sweetness-level-text').text(variant_sweetness_level_text);
    }
    if($parent_product_template.find('.dynamic-data-product-variant').length > 0) {
      $parent_product_template.find('.dynamic-data-product-variant').each( function() {
        $(this).attr('data-product-variant', variant_id);
        if($(this).parents('li').hasClass('active')) {
          $(this).trigger('click');
        }
      });
    }
  });
  
  $(document.body).on('change', '.product-flavor-option', function() {
    var $parent_form = $(this).parents('form');
    var $selected_flavor_option = $parent_form.find('.product-flavor-option:checked');
    if($selected_flavor_option.length < 1) {
      return;
    }
    console.log('product-flavor-option change');
    
    var change_flavor_action = $selected_flavor_option.attr('data-action');
    var flavor_url = $selected_flavor_option.val();
    if(change_flavor_action == 'go_to_url') {
      window.location.href = flavor_url;
      return;
    }
    var $parent_product_container = $parent_form.parents('.product-container');
    if($parent_product_container.length === 0) {
      return;
    }
    if(change_flavor_action == 'load_new_options') {
      load_new_product_options($parent_product_container,flavor_url);
    }
    if(change_flavor_action == 'load_new_product') {
      load_new_single_product($parent_product_container,flavor_url);
    }
    update_dynamic_variant_url($parent_product_container, flavor_url);
  });

  $(document.body).on('change', '.new-product-variant-option', function() {
    var option_name = $(this).attr('name');
    var $parent_form = $(this).parents('form');
    var $checked_product_variant_option = $parent_form.find('input[name="'+option_name+'"]:checked');
    var change_action = $checked_product_variant_option.attr('data-action');
    var variant_url = $checked_product_variant_option.attr('data-variant-url');
    
    if(change_action == 'go_to_url') {
      window.location.href = variant_url;
      return;
    }
    
    var $parent_product_container = $parent_form.parents('.product-container');
    if($parent_product_container.length === 0) {
      return;
    }
    
    if(change_action == 'load_new_product') {
      load_new_single_product($parent_product_container,variant_url);
      update_window_url(variant_url);
    }
    if(change_action == 'load_new_options') {
      load_new_product_options($parent_product_container,variant_url);
    }
    if(change_action == 'load_new_images') {
      load_new_product_images($parent_product_container,variant_url);
    }
    update_dynamic_variant_url($parent_product_container, variant_url);
    /* following for updating data-product-variant-id attr in product info table (product template only) */
    var $parent_product_template = $parent_product_container.parents('.template-product');
    if($parent_product_template.length === 0) {
      return;
    }
    var variant_id = $checked_product_variant_option.val();
    if($parent_product_template.find('.contentSection.ajaxLoaded').length > 0) {
      $parent_product_template.find('.contentSection.ajaxLoaded').addClass('ajaxNotLoaded'); /* to reset things like nutrition facts if already been clicked */
    }
    if($parent_product_template.find('.dynamic-data-product-variant').length > 0) {
      $parent_product_template.find('.dynamic-data-product-variant').each( function() {
        $(this).attr('data-product-variant', variant_id);
        if($(this).parents('li').hasClass('active')) {
          $(this).trigger('click');
        }
      });
    }
  });

  /** Begin Electrolytes Sweetness Stuff **/
  $(document.body).on('change', '.product-sweetness-option', function() {
    var $parent_form = $(this).parents('form');
    var $selected_sweetness_option = $parent_form.find('.product-sweetness-option:checked');
    if($selected_sweetness_option.length < 1) {
      return;
    }
    
    var change_sweetness_action = 'go_to_url';
    var sweetness_url = $selected_sweetness_option.val();
    if(change_sweetness_action == 'go_to_url') {
      window.location.href = sweetness_url;
      return;
    }
  });
  /** End Electrolytes Sweetness Stuff **/

  /** Begin Debloat 3x, 6x stuff **/
  $(document.body).on('change', '.selling-plan-option', function() {
    var $parent_form = $(this).parents('form');
    var $checked_selling_plan_option = $parent_form.find('.selling-plan-option:checked');
    var $subscription_frequency = $parent_form.find('.product-subscription-frequency');
    if($subscription_frequency.length > 0) {
      $subscription_frequency.removeAttr('name');
    }
    var corresponding_variant_id = $checked_selling_plan_option.attr('data-variant-id');
    var $checked_variant_option = $parent_form.find('.product-variant-option:checked');
    $checked_variant_option.val(corresponding_variant_id);
  });
  $(document.body).on('click', 'a[href*="3x"]', function(e) {
    console.log('clicked one of them linkes');
    e.preventDefault();
    var href = $(this).attr('href');
    var new_href = href.replace('3x-','');
    window.location.href = new_href;
  });
  /** End Debloat 3x, 6x stuff **/

  $(document.body).on('change', '.corresponding-variant-select', function() {
    var selection = $(this).val(),
      $selection = $(selection);
    if($selection.length > 0) {
      $selection.prop('checked',true).trigger('change');
    }
  });

  $('.productLoop .image img').on('load', function() {
    $(this).parents('.productLoop').removeClass('loadingImage');
  });

  $(document.body).on('click', '.product-available-flavor', function(e) {
    e.preventDefault();
    var $available_flavor = $(this);
    $available_flavor.parents('li').addClass('selected').siblings('li').removeClass('selected');
    var $parent_product_loop = $available_flavor.parents('.productLoop');
    $parent_product_loop.addClass('loadingImage');
    var $product_loop_image = $parent_product_loop.find('.productLoopImage');
    var flavor_image = $available_flavor.attr('data-flavor-image');
    $product_loop_image.attr('src', flavor_image);
    var flavor_url = $available_flavor.attr('href');
    update_dynamic_variant_url($parent_product_loop, flavor_url);
    if($('.ajax-filtered').length > 0) {
      $parent_product_loop.removeClass('loadingImage'); /* for flavor selector changing images after filtering */
    }
    var $update_flavor_description = $parent_product_loop.find('.update-flavor-description');
    if($update_flavor_description.length > 0) {
      var flavor_description = $available_flavor.attr('data-flavor-description');
      if(flavor_description != 'false') {
        $update_flavor_description.text(flavor_description);
      }
    }
  });

  $(document.body).on('click', '.open-productQuickShop', function(e) {
    e.preventDefault();
    $('.productQuickShop').removeClass('active');
    var product_or_variant_url = $(this).attr('href');
    var $product_quick_shop = $($(this).attr('data-quick-shop'));
    var $product_container = $product_quick_shop.parents('.product-container');
    load_new_product_options($product_container,product_or_variant_url);
    $('body').addClass('with-productQuickShop-active');
    $product_quick_shop.addClass('active');
  });

  $(document.body).on('click', '.productQuickShop .closeX,.blackBack', function() {
    $('body').removeClass('with-productQuickShop-active');
    $('.productQuickShop').removeClass('active');
  });

  /****** END Product Purchase Options Scripts *******/

  
  
  /****** Single Product Scripts *******/

  function calculate_thumbnail_scroll($product_container) {
    var $product_image_thumbnails = $product_container.find('.productImageThumbnails');
    var product_image_height = $product_image_thumbnails.height(),
      thumb_height = $product_image_thumbnails.find('div').outerHeight(),
      thumb_count = $product_image_thumbnails.find('div').length,
      all_thumbs_height = thumb_count * thumb_height,
      scroll_distance = all_thumbs_height - product_image_height;
    if(scroll_distance < 0) {
      $product_container.find('.productImageThumbnailsScroll').hide();
    } else {
      $product_container.find('.productImageThumbnailsScroll').show();
    }
    return scroll_distance;
  }
  
  var $single_product = $('.singleProduct');
  if($single_product.length > 0) {
    $(window).on('load resize', function() {
      $('.singleProduct').each( function() {
        fire_product_image_slider($(this), false);
        calculate_thumbnail_scroll($(this));
      });
    });
  }
  
  $('.singleProduct').on('click', '.productImageThumbnails > div', function() {
    var slideIndex = $(this).index();
    $('.singleProduct').find('.productImages').slick('slickGoTo', (parseInt(slideIndex)));
  });
  $('.singleProduct').on('click', '.productImageThumbnailsScroll', function() {
    var scroll_distance = calculate_thumbnail_scroll($(this).parents('.singleProduct'));
    var $product_image_thumbnails = $(this).siblings('.productImageThumbnails');
    $product_image_thumbnails.animate({'scrollTop': scroll_distance}, 0);
  });
  
  if($('.productImages').find('.video').length > 0) {
    $('.productImages').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var $next_slide = $(this).find('div[data-slick-index="'+nextSlide+'"]');
      if($next_slide.hasClass('video')) {
        if($next_slide.hasClass('videoLoaded')) {
          return;
        }
        var $next_slide_video = $next_slide.find('video');
        var $next_slide_video_source = $next_slide_video.find('source');
        var video_src = $next_slide_video_source.attr('data-src');
        $next_slide_video_source.attr('src', video_src);
        $next_slide_video.load();
        $next_slide.addClass('videoLoaded');
      }
    });
    $('.productImages').on('click', '.video', function() { /* for mobile when not slider */
      if($(this).hasClass('videoLoaded')) {
        return;
      }
      var $this_slide_video = $(this).find('video');
      var $this_slide_video_source = $this_slide_video.find('source');
      var video_src = $this_slide_video_source.attr('data-src');
      $this_slide_video_source.attr('src', video_src);
      $this_slide_video.load();
      $(this).addClass('videoLoaded');
    });
  }

  var ingredients_list_slider_fired = false;
    
  function fire_ingredients_list_slider() {
    if(ingredients_list_slider_fired) {
      return;
    }
    if($('.ingredientsList-product .itemGrid-sliderEnabled .gridItem').length > 1) {
      $('.ingredientsList-product .itemGrid-sliderEnabled').slick({
        speed: 300,
        arrows: false,
        autoplay: false,
        infinite: true,
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 2
      });
    }
    ingredients_list_slider_fired = true;
  }
  
  function load_infotable_content(target,source,delay) { 
    if($(target).hasClass('ajaxNotLoaded')) { 
      $(target).removeClass('ajaxNotLoaded').addClass('ajaxLoading');
      setTimeout( function() { 
        $(target).load(source, function() { 
          $(target).removeClass('ajaxLoading').addClass('ajaxLoaded');
          if($(target).attr('id') == 'content-ingredients') {
            ingredients_list_slider_fired = false;
            fire_ingredients_list_slider();
          }
        });
      },delay);
    }
  }
  
  $('.productInfoTable .tableNav a').on('click', function(e) {
    e.preventDefault();
    var $this = $(this);
    var target_content_section = $this.attr('href'),
        $target_content_section = $(target_content_section);
    if($target_content_section.length > 0) {
      $this.parents('li').addClass('active').siblings('li').removeClass('active');
      if($(window).width() > 850) {
        $('.contentSection').removeClass('contentSection-active'); /* Because of doubling up these sections for mobile view */
      }
      $target_content_section.addClass('contentSection-active').siblings('.contentSection').removeClass('contentSection-active');
      if($this.hasClass('load-content')) {
        var product_handle = $this.attr('data-product-handle');
        var product_variant = $this.attr('data-product-variant');
        var product_template = $this.attr('data-product-template');
        if(product_variant && product_variant != 'false') {
          load_infotable_content(target_content_section, '/products/'+product_handle+'?variant='+product_variant+'&view='+product_template, 50);
        } else {
          load_infotable_content(target_content_section, '/products/'+product_handle+'?view='+product_template, 50);
        }
      }
    }
  });

  if($(window).width() <= 850 && $('.tableNav-2 li').length > 0) {
    $(window).on('load', function() {
      setTimeout( function() {
        $('.tableNav-2 li:first-of-type a').trigger('click');
      }, 1000);
    });
  }

  $('.ingredientsTriggerLink').on('click', function(e) {
    e.preventDefault();
    $('.productInfoTable').find('.navItem-ingredients a').trigger('click');
    var target = document.getElementById('productInfoTable');
    target.scrollIntoView({ behavior: 'smooth' });
  });
  $('.testingTriggerLink').on('click', function(e) {
    e.preventDefault();
    $('.productInfoTable').find('.navItem-testing-data a').trigger('click');
    var target = document.getElementById('productInfoTable');
    target.scrollIntoView({ behavior: 'smooth' });
  });

  /****** END Single Product Scripts *******/



  /****** Activate Miscellaneous Sliders and moving elements throughout site ******/

  if($('#bannerSlider').length > 0) {
    setTimeout( function() {
      $('#bannerSlider').slick({
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true
      });
    }, 3000);
  }
  
  if($('.ingredientsList-page .itemGrid-sliderEnabled .gridItem').length > 4) {
    $('.ingredientsList-page .itemGrid-sliderEnabled').slick({
      speed: 300,
      arrows: false,
      autoplay: false,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      responsive: [
        {
          breakpoint: 850,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  } else if($('.ingredientsList-page .itemGrid-sliderEnabled').length > 0) {
    var ingredients_list_sliders_enabled = false;
    $(window).on('load resize', function() {
      if($(window).width() > 850) {
        if(ingredients_list_sliders_enabled) {
          $('.ingredientsList-page .itemGrid').slick('unslick');
          ingredients_list_sliders_enabled = false;
        }
      } else {
        if(!ingredients_list_sliders_enabled) {
          $('.ingredientsList-page .itemGrid').slick({
            speed: 300,
            arrows: false,
            autoplay: false,
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            dots: true
          });
          ingredients_list_sliders_enabled = true;
        }
      }
    });
  } /* end if .ingredientsList-page .itemGrid */

  function activate_featured_reviews_slider() {
    if($('.featuredReviews .itemGrid').length > 0) {
      $('.featuredReviews .itemGrid').slick({
        speed: 300,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 6000,
        infinite: true,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [
          {
            breakpoint: 850,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }
  
  function activate_albert_testimonials_slider() {
    if($('.albertTestimonials').length > 0) {
      $('.albertTestimonials').slick({
        speed: 300,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 6000,
        infinite: true,
        dots: true
      });
    }
  }

  function activate_authentic_partnerships_slider() {
    if($('.authenticPartnershipsSideBySide .imageSlider').length > 0) {
      $('.authenticPartnershipsSideBySide .imageSlider').slick({
        arrows: true,
        dots: false
      });
    }
  }

  function activate_misc_slider(slider) {
    switch(slider) {
      case 'featured_reviews':
        activate_featured_reviews_slider();
        break;
      case 'albert_testimonials':
        activate_albert_testimonials_slider();
        break;
      case 'authentic_partnerships':
        activate_authentic_partnerships_slider();
        break;
      default: 
        console.log('no matching slider found');
        return;
    }
  } /* end function activate_misc_slider */
  
  activate_misc_slider('featured_reviews');
  activate_misc_slider('albert_testimonials');
  activate_misc_slider('authentic_partnerships');
  
  if($('.proteinBarsSideBySide .imageSlider').length > 0) {
    $('.proteinBarsSideBySide .imageSlider').slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000,
      dots: true
    });
  } /* end if .proteinBarsSideBySide .imageSlider */

  if($('.productValueSlider').length > 0) {
    $('.productValueSlider').slick({
      arrows: false,
      autoplay: true,
      autoplaySpeed: 4000
    });
  } /* end if .productValueSlider */
  
  /****** END Activate Miscellaneous Sliders and moving elements throughout site ******/

  
  /****** Fancy Quantity Scripts *******/

  $(document.body).on('click', '.fancyQuantity .btn-number', function(e){
    e.preventDefault();
    fieldName = $(this).attr('data-field');
    type      = $(this).attr('data-type');
    var input = $("input[id='"+fieldName+"']");
    var currentVal = parseInt(input.val());
    if (!isNaN(currentVal)) {
      if(type == 'minus') {
        if(currentVal > input.attr('min')) {
          input.val(currentVal - 1).change();
        } 
        if(parseInt(input.val()) == input.attr('min')) {
          $(this).attr('disabled', true);
        }
      } else if(type == 'plus') {
        if(currentVal < input.attr('max')) {
          input.val(currentVal + 1).change();
        }
        if(parseInt(input.val()) == input.attr('max')) {
          $(this).attr('disabled', true);
        }
      }
    } else {
      input.val(0);
    }
  });
  $(document.body).on('focusin', '.fancyQuantity .input-number', function(){
     $(this).data('oldValue', $(this).val());
  });
  $(document.body).on('change', '.fancyQuantity .input-number', function() {
    if($(this).hasClass('quantityDisabled')) { return; }
    minValue =  parseInt($(this).attr('min'));
    maxValue =  parseInt($(this).attr('max'));
    valueCurrent = parseInt($(this).val());
    name = $(this).attr('id');
    if(valueCurrent >= minValue) {
      $(".btn-number[data-type='minus'][data-field='"+name+"']").removeAttr('disabled')
    } else {
      alert('Sorry, the minimum value was reached');
      $(this).val($(this).data('oldValue'));
    }
    if(valueCurrent <= maxValue) {
      $(".btn-number[data-type='plus'][data-field='"+name+"']").removeAttr('disabled')
    } else {
      alert('Sorry, the maximum value was reached');
      $(this).val($(this).data('oldValue'));
    }
  });
  $(document.body).on('keydown', '.fancyQuantity .input-number', function (e) {
    // Allow: backspace, delete, tab, escape and enter
    if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 ||
        // Allow: Ctrl+A
        (e.keyCode == 65 && e.ctrlKey === true) || 
        // Allow: home, end, left, right
        (e.keyCode >= 35 && e.keyCode <= 39)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  });

  /****** END Fancy Quantity Scripts *******/

  
  /****** Load sections ******/

  function load_section(placeholder_id, sub_handle) {
    var section_placeholder = document.getElementById(placeholder_id);
    if(section_placeholder.classList.contains('section-loaded') || section_placeholder.classList.contains('section-loading')) {
      return;
    }
    section_placeholder.classList.add('section-loading');
    var requestRoot = location.pathname + (location.search ? location.search + "&" : "?");
    var section_id = section_placeholder.getAttribute('data-section');
    requestRoot = requestRoot + "section_id=" + section_id;
    console.log('Loading section, requestRoot: ', requestRoot);
    fetch(requestRoot)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          section_placeholder.classList.remove('section-loading');
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const section_markup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-'+section_id).innerHTML;
        section_placeholder.innerHTML = section_markup;
        section_placeholder.classList.add('section-loaded');
        section_placeholder.classList.remove('section-loading');
        if(section_placeholder.classList.contains('with-slider')) {
          var slider = section_placeholder.getAttribute('data-slider');
          activate_misc_slider(slider);
        }
        if(sub_handle) {
          show_corresponding_sub(sub_handle);
        }
      })
      .catch((error) => {
        section_placeholder.classList.remove('section-loading');
        throw error;
      });
  } /* end function load_section */

  /*** Loading header nav dropdowns and search bar suggestions ***/
  
  function show_corresponding_sub(sub_handle) {
    var $sub = $('#sub-'+sub_handle);
    if($sub.length > 0) {
      if($sub.hasClass('featuredMenuSub')) {
        var main_offset = $('nav.main > ul > li:first-of-type').offset().left,
          max_width = $(window).width() - main_offset;
        $sub.find('.featuredMenu > ul').css({'margin-left': main_offset, 'max-width': max_width});
      }
      $sub.show();
      $sub.find('img.lazyload').each( function() {
        var src = $(this).attr('src'),
          data_src = $(this).attr('data-src');
        if(src != data_src) {
          $(this).attr('src', data_src);
        }
      });
    }
  } /* end function show_corresponding_sub */

  var header_nav_sub_container_id = 'header-nav-sub-container',
    $header_nav_sub_container = $('#'+header_nav_sub_container_id);

  function load_nav_header_dropdows(sub_handle) {
    if($header_nav_sub_container.length === 0) {
      return;
    }
    load_section(header_nav_sub_container_id, sub_handle);
  } /* end function load_nav_header_dropdows */
  
  $('nav.main a').hover( function() {
    $('.hiddenSub').hide();
    $('nav.main a').removeClass('hovered');
    var sub_handle = $(this).attr('data-sub');
    if(sub_handle == 'false') {
      return;
    }
    $(this).addClass('hovered');
    if($header_nav_sub_container.hasClass('section-loaded')) {
      show_corresponding_sub(sub_handle);
    } else {
      $header_nav_sub_container.addClass('dropdowns-loading');
      load_nav_header_dropdows(sub_handle);
      setTimeout( function() { /* just in case */
        show_corresponding_sub(sub_handle);
      }, 1000);
    }
  });

  $('#header').on('mouseover', function() {
    if($(window).width() > 1150) {
      load_section(header_nav_sub_container_id);
    }
  });
  
  var $predictive_search = $('#searchBar').find('predictive-search');
  var $predictive_search_suggestions = $predictive_search.find('.predictive-search');
  function load_search_bar_suggestions() {
    if($predictive_search.length > 0) {
      if($predictive_search_suggestions.hasClass('loaded')) {
        return;
      }
      var source = '/search?view=suggestions',
        search_url = $predictive_search.find('form').attr('action');
      if(search_url.includes('/search')) { /* to ensure language/location is in root url, e.g. /en-uk/search */
        source = search_url + '?view=suggestions';
      }
      $predictive_search_suggestions.load(source, function() {
        $predictive_search.removeAttr('loading');
        $predictive_search_suggestions.addClass('loaded');
      });
    }
  }
  $('.open-searchBar').on('click', function(e) {
    e.preventDefault();
    $('body').addClass('with-searchBar-open');
    setTimeout( function() {
      $('.searchBar').find('.searchInput').focus();
    }, 1500);
    load_search_bar_suggestions();
  });
  $('.close-searchBar').on('click', function() {
    $('body').removeClass('with-searchBar-open');
    $predictive_search_suggestions.removeClass('loaded');
  }); /* no longer firing load_search_bar_suggestions on window.load, just do it on command */
  
  $('.open-sidebarMenu').on('click', function(e) {
    e.preventDefault();
    $('body').addClass('with-sidebarMenu-open');
    var sidebar_nav_id = $(this).attr('data-nav'),
      $sidebar_nav = $('#'+sidebar_nav_id);
    $('.sidebarNav').hide();
    $sidebar_nav.show();
    load_section(sidebar_nav_id, false);
    var $sidebar_predictive_search = $('#sidebarMenu').find('.predictive-search');
    if($sidebar_predictive_search.length > 0) {
      var max_height = $(window).height() - ($('predictive-search').offset().top + $('predictive-search').height());
      $sidebar_predictive_search.css('max-height', max_height);
    }
  });
  
  /****** Misc Scrolling Animation Scripts ******/

  /** Newsletter email animation **/
  var footer_offset_trigger = $('#footer').offset().top - $(window).height() + 150;

  var $email_element,
    i = 0,
    email_start_txt = '',
    email_txt = 'Enter your email';
  
  function newsletter_animation() {
    if (i < email_txt.length) {
      $email_element.attr('placeholder', email_start_txt += email_txt.charAt(i));
      i++;
      setTimeout(newsletter_animation, 200);
    } else {
      i = 0;
      email_start_txt = '';
      setTimeout( function() {
        $email_element.attr('placeholder', email_start_txt);
      }, 1000);
      setTimeout(newsletter_animation, 1200);
    }
  }

  var newsletter_animation_enabled = false;
  function enable_newsletter_animation() {
    if(newsletter_animation_enabled) {
      return;
    }
    var $klaviyo_email_element = $('#footer .newsletterKlaviyoForm').find('input[name="email"]');
    if($klaviyo_email_element.length > 0) {
      $email_element = $klaviyo_email_element;
      newsletter_animation();
      newsletter_animation_enabled = true;
    }
  }

  var lastScrollTop = 0;
  if($('.template-index').length > 0) {
    var is_homepage = true;
  }
  if($('#singleProduct').length > 0) {
    var is_product_page = true;
    var fixed_options_offset = $('#singleProduct').outerHeight(); /* Was $('#singleProduct').outerHeight() + $('#header').outerHeight() but works better this way */
  }
  if(is_homepage) {
    var featured_reviews_offset = $('#featured-reviews-placeholder').offset().top - $(window).height() + 100;
    var authentic_partnerships_offset = $('#authentic-partnerships-placeholder').offset().top - $(window).height() + 200;
    var shop_by_health_goal_offset = $('#shop-by-health-goal-placeholder').offset().top - $(window).height() + 300;
    var farm_direct_offset = $('#farm-direct-placeholder').offset().top - $(window).height() + 400;
    var brand_standards_offset = $('#brand-standards-placeholder').offset().top - $(window).height() + 500;
    var about_company_offset = $('#about-company-placeholder').offset().top - $(window).height() + 600;
    var albert_side_by_side_offset = $('#albert-side-by-side-placeholder').offset().top - $(window).height() + 700;
    var homepage_below_offset = $('#homepage-below-placeholder').offset().top - $(window).height() + 800;
    var pie_charts_animation_offset = $('#about-company-placeholder').offset().top - $(window).height() + 250;
    var brand_standards_animation_offset = $('#brand-standards-placeholder').offset().top - $(window).height() + 100;
  }
  window.addEventListener("scroll", function() {
    var st = window.pageYOffset || document.documentElement.scrollTop;
    if (st > lastScrollTop){
      // downward scroll
      if(st > $('#header').height()) {
        $('body').addClass('with-header-hidden');
      }
      if(is_homepage) {
        if(st > featured_reviews_offset) {load_section('featured-reviews-placeholder');}
        if(st > authentic_partnerships_offset) {load_section('authentic-partnerships-placeholder');}
        if(st > shop_by_health_goal_offset) {load_section('shop-by-health-goal-placeholder');}
        if(st > farm_direct_offset) {load_section('farm-direct-placeholder');}
        if(st > brand_standards_offset) {load_section('brand-standards-placeholder');}
        if(st > about_company_offset) {load_section('about-company-placeholder');}
        if(st > albert_side_by_side_offset) {load_section('albert-side-by-side-placeholder');}
        if(st > homepage_below_offset) {load_section('homepage-below-placeholder');}
        pie_charts_animation_offset = $('#about-company-placeholder').offset().top - $(window).height() + 250;
        if(st > pie_charts_animation_offset) {
          $('#animatedPieCharts').addClass('animated');
        }
        brand_standards_animation_offset = $('#brand-standards-placeholder').offset().top - $(window).height() + 100;
        if(st > brand_standards_animation_offset) {
          // console.log('brandStandards reached');
          $('#brandStandards').addClass('animated');
        }
      } /* end if is_homepage */
      if(st > footer_offset_trigger) {
        enable_newsletter_animation();
      }
    } else {
      // upward scroll
      $('body').removeClass('with-header-hidden');
    }
    if(is_product_page) {
      fixed_options_offset = $('#singleProduct').outerHeight();
      if(st > fixed_options_offset) {
        $('body').addClass('with-fixed-product-atc');
      } else {
        $('body').removeClass('with-fixed-product-atc');
      }
    }
    lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
  }, false);
  
  /****** END Misc Scrolling Animation Scripts ******/
  
  /*** Get Customer Dietary Restriction, if exists ***/
  var customer_dietary_restriction = localStorage.getItem('dietary_restriction');
  if(customer_dietary_restriction && customer_dietary_restriction.length) {
    console.log('customer_dietary_restriction: '+customer_dietary_restriction);
    $('.productGrid .dietary-restrictions-'+customer_dietary_restriction).addClass('recommended');
  }
  
  /** open cart if hash exists on page load **/
  if(window.location.hash == '#open-cart') {
    $(window).load( function() {
      setTimeout( function() {
        Rebuy.SmartCart.show();
      },1000);
    });
  }

  /** Load larger size images for desktop **/
  if($(window).width() > 650) {
    if($('img.loadLargerSize').length > 0) {
      $('img.loadLargerSize').each( function() {
        var large_img_url = $(this).attr('data-src-large');
        $(this).attr('data-src', large_img_url);
      });
    }
  }
  
}); /* End document.ready */

window.addEventListener("load", function(event) {
  lazyload();
});

$('.headerNav').on('mouseover', '.nav-hover-trigger', function() {
  var $this = $(this),
    $parent_featured_menu = $this.parents('.featuredMenu'),
    $nav_hover_placeholder = $parent_featured_menu.find('.nav-hover-placeholder');
  if($nav_hover_placeholder.length > 0) {
    var $nav_hover_image = $this.find('.nav-hover-image');
    if($nav_hover_image.length > 0) {
      $nav_hover_placeholder.html($nav_hover_image.html());
    }
  }
});
$('#header').mouseleave( function() {
  $('.hiddenSub').hide();
  $('nav.main a').removeClass('hovered');
  $('body').removeClass('with-header-hidden');
});
$('.sidebarMenu .closeX,.whiteBack').on('click', function() {
  $('body').removeClass('with-sidebarMenu-open');
});
$('.continueReading').on('click', function(e) {
  e.preventDefault();
  $(this).parents('.readingExcerpt').hide();
  var continue_reading_text = $(this).attr('href');
  $(continue_reading_text).show();
});
$('#sort_by').change( function() {
  var value = $(this).val();
  window.location.href = '?sort_by='+value;
});
$('a.toggleFAQ').click( function(e) {
  e.preventDefault();
  $(this).parents('.gridFAQ').toggleClass('expanded');
  $(this).next('.faqToggleContent').slideToggle(100);
});

$('a[href^="#"]:not(nav a,a.noScroll)').bind('click.smoothscroll',function (e) {
  if(this.hash != '' && this.hash != '#mobileMenu') {
    e.preventDefault();
    console.log('executing smoothscroll');
    var target = this.hash,
        $target = $(target);
    $('html, body').stop().animate({
      'scrollTop': $target.offset().top
    }, 500, 'swing', function () {
      window.location.hash = target;
    });
  }
});
$('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
  $(this).blur();
});

$('a.download-file').on('click', function(e) {
  e.preventDefault();
  var url = $(this).attr('href');
  var fileName = $(this).attr('data-filename');
  var req = new XMLHttpRequest();
  req.open("GET", url, true);
  req.responseType = "blob";
  req.onload = function () {
    var blob = new Blob([req.response], { type: "application/octetstream" });
    var url = window.URL || window.webkitURL;
    link = url.createObjectURL(blob);
    var a = document.createElement("a");
    a.setAttribute("download", fileName);
    a.setAttribute("href", link);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  req.send();
});